module.exports = __webpack_public_path__ + "img/renaissance_cleaning_services_8.153df78d.jpg";